import { cn } from '@/utils/cn';

interface LogoProps {
  className?: string;
  size?: number;
}

/**
 * Placeholder Clinio mark. Replace with the v1 SVG asset when MOD-0 ships.
 * Sized via a single `size` prop so it can be used inline in the sign-in
 * card and the sidebar header.
 */
export function Logo({ className, size = 40 }: LogoProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-lg bg-ds-teal font-bold text-ds-on-accent',
        className,
      )}
      style={{ width: size, height: size, fontSize: size * 0.45 }}
      aria-label="Clinio"
    >
      C
    </div>
  );
}
